import React from "react";

function MQSeriesTutorial() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto", lineHeight: "1.7", textAlign: "justify" }}>
      <h1 style={{ textAlign: "center" }}>How to Create and Run a MQ Program</h1>

<p>
      <ol>
        <li>
          Install MQ Series.<br />
          Go to command prompt and use command:
          <pre>
            <code>
-&gt; crtmqm QM1 (to create queue manager. Here "QM1" is your queue manager's name)
-&gt; runmqsc QM1
            </code>
          </pre>
          <p>
            After running <code>runmqsc</code>, you will get a new prompt where you need to run commands related to queues:
          </p>
          <pre>
            <code>
$ create qlocal MyLocalQ
            </code>
          </pre>
        </li>

        <li>
          Go to Example directory
        </li>

        <li>
          Use <code>amqsputc.exe</code> to put a message into MQ Queue:
          <pre>
            <code>
-&gt; amqsputc QM1 MyLocalQ "My Message goes here"
            </code>
          </pre>
        </li>

        <li>
          Use <code>amqsgetc</code> to get a message from queue:
          <pre>
            <code>
-&gt; amqsgetc QM1 MyLocalQ
            </code>
          </pre>
          <p>You receive the message which you had put on the queue, i.e., "My Message goes here". Just wanted to teach you the very basic exercise.</p>
        </li>
      </ol></p>

      <h2>Introduction to MQ API</h2>
      <p>This is the starting point for learning MQ APIs, including putting/getting messages, connecting to queue managers, and managing queues programmatically.</p>
    </div>
  );
}

export default MQSeriesTutorial;
